import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getStaffProfileProgress(id: number) {
  return restApiClient
    .url(constructApiUrl(API.staffs.getStaffProfileProgress.url, { id }))
    .get<number>()
}
